import React from 'react';
import { useStaticGeneration } from '../shared/contexts/StaticGenerationContext';
import {
  Navigate,
  Outlet,
  useLocation,
} from 'react-router-dom';

import { useAuth } from '../features/auth/AuthContext';
import StatePage, {
  FullPageLoader,
} from '../features/system/state/StatePage';

import { ROUTES } from '../config/routes';

export default function ProtectedRoute() {
  const location = useLocation();
  const isStatic = useStaticGeneration();

  const {
    status,
    isSessionRestoring,
    refreshAuth,
  } = useAuth();

  if (isStatic || isSessionRestoring || status === 'loading') {
    return <FullPageLoader />;
  }

  if (status === 'error') {
    return (
      <StatePage
        standalone
        icon="warning"
        titleKey="state.authError.title"
        descriptionKey="state.authError.description"
        actionKey="state.authError.retry"
        onAction={refreshAuth}
      />
    );
  }

  if (status !== 'authenticated') {
    return (
      <Navigate
        to={ROUTES.login}
        replace
        state={{ from: location }}
      />
    );
  }

  return <Outlet />;
}